import React, { useEffect, useState } from "react";
import { AiOutlineEdit } from "react-icons/ai";
import DecorativeSquares from "../../components/ui/DecorativeSquares";
import { useNavigate, useParams } from "react-router-dom";
import Initials from "../../components/Initials/Initials";
import { FiPhoneCall } from "react-icons/fi";
import InputBase from "../../components/form/inputs/InputBase";
import subscriber from "../../assets/images/svgs/other/subsctibedusers.svg";
import SecondaryBtn from "../../components/button/SecondaryBtn";
import Collectpay from "../../components/Modals/Collectpay";
import Addnewcustomers from "../Addnewcustomers";
import Editcustomer from "../../components/Modals/Editcustomer";
import { useDispatch, useSelector } from "react-redux";
import { getCustomerRecords } from "../../redux/thunks/customerRecordThunk";
import CustomerDetailShimmer from "../../components/Preloader/CustomerDetailShimmer";
import { saveSubsOrderDraft } from "../../redux/slices/SubscriptionDraftSlice";
import { FaArrowLeft } from "react-icons/fa";
import { decryptId, encryptId } from "../../utils/urlCrypto";

const Detail = () => {
  const dispatch = useDispatch();
  const { isCustmerLoading } = useSelector((state) => state.customerRecords);
  const navigate = useNavigate();
  const [isPayopen, setIsPayopen] = useState(false);
  const [isEditCustomer, setIsEditCustomer] = useState(false);
  const [customerName, setCustomerName] = useState("");
  const [customerNumber, setCustomerNumber] = useState("");
  const [customerCode, setCustomerCode] = useState("");
  const [customersAdd, setCustomersAdd] = useState("");
  const { customer_id } = useParams();
  const customerId = decryptId(customer_id);
  const handleGoBack = () => {
    navigate("/customer");
  };

  const handleSubscription = () => {
    navigate(`/subscription/${encryptId(customerId)}`);
  };
  const handleBalanceView = () => {
    navigate(`/balance/${encryptId(customerId)}`);
  };
  const handleOrderView = () => {
    navigate(`/order-history/${encryptId(customerId)}`);
  };
  const handlePayView = () => {
    navigate(`/payment-history/${encryptId(customerId)}`);
  };

  // useEffect(() => {
  //   console.log("The customer id from url is:", customer_id);
  // });

  // API logics to get details of the user
  const [totalAm, setTotalAm] = useState(null);
  const [paymentRc, setPaymentRc] = useState(null);
  const [amountDu, setAmountDu] = useState(null);
  const [BalanceType, setBalanceType] = useState(null);
  const [totalTC, setTotalTC] = useState(null);
  const [subscribeCount, setSubscribeCount] = useState(0);
  const [Curr, setCurr] = useState("");
  const [isAddress, setisAddress] = useState(null);
  const fetchCustomerDetail = () => {
    const payload = { service_provider_customer_id: customerId };
    dispatch(getCustomerRecords(payload))
      .unwrap()
      .then((res) => {
        // console.log("The res of detail is :", res.data);
        setCustomerName(res.data?.customer_name);
        setCustomerNumber(res.data?.contact_no);
        setCustomerCode(res.data?.country_code);
        setisAddress(res.data?.default_address);
        const address1 = res.data?.default_address?.address_1 || "";

        setCustomersAdd(address1);

        const totalAmount = res.data?.total_amount;
        setTotalAm(totalAmount);

        const paymentRecieved = res.data?.payment_received;
        setPaymentRc(paymentRecieved);

        const amountDue = res.data?.amount_due;
        setAmountDu(amountDue);

        const getbalanceType = res.data?.balance_type;
        setBalanceType(getbalanceType);

        const totaltiffin = res.data?.total_tiffins_consumed;
        setTotalTC(totaltiffin);

        const totalSubscription = res.data?.active_meal_plan_count;
        setSubscribeCount(totalSubscription);

        const getCurr = res.data?.currency_symbol;
        // console.log("the res of currency is :", getCurr);
        setCurr(getCurr);
      });
  };
  useEffect(() => {
    fetchCustomerDetail();
  }, [customerId]);

  const getInitials = (name = "") => {
    const words = name.trim().split(" ").filter(Boolean);

    if (words.length === 0) return "";

    // If only one word → return first 2 letters
    if (words.length === 1) {
      return words[0].slice(0, 2).toUpperCase();
    }

    // If multiple words → first letter of first & second word
    return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
  };

  if (isCustmerLoading) {
    return <CustomerDetailShimmer />;
  }
  return (
    <section className="relative max-w-7xl mx-auto px-4 py-6 ">
      <DecorativeSquares />
      <div className="sticky top-2 z-10 bg-white/80 backdrop-blur-md rounded-2xl shadow-md px-4 py-3 flex items-center justify-between mb-6">
        <button
          onClick={handleGoBack}
          className="flex items-center p-2 rounded-full hover:bg-gray-100 transition"
        >
          <FaArrowLeft size={20} />
        </button>

        <h1 className="mx-auto text-2xl font-semibold tracking-tight text-gray-900">
          Customer Details
        </h1>
      </div>

      <div className=" mt-8 space-y-4">
        <div className="mx-auto w-full max-w-7xl bg-transparent md:bg-white border-none md:border md:border-gray-100 md:rounded-2xl p-2  md:p-8 md:shadow-lg space-y-6">
          <div className="flex justify-between">
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-5">
                <Initials initial={getInitials(customerName)} />

                <div>
                  <h2 className="text-lg font-semibold text-gray-900">
                    {customerName}
                  </h2>
                  <p className="flex items-center gap-2 text-sm text-gray-500 mt-1">
                    <FiPhoneCall size={12} />+{customerCode} {customerNumber}
                  </p>
                </div>
              </div>
            </div>

            <button
              type="button"
              onClick={() => setIsEditCustomer(true)}
              className="
                  flex items-center justify-center
                  h-12 w-12
                  rounded-md
                  border border-gray-300
                  bg-white
                  text-gray-600
                  hover:bg-gray-100 hover:text-gray-800
                  active:scale-95
                  transition
                  focus:outline-none focus:ring-2 focus:ring-gray-300
                "
              aria-label="Edit"
            >
              <AiOutlineEdit className="text-[22px]" />
            </button>
          </div>

          {isAddress === null ? (
            <button
              onClick={() =>
                navigate(`/customer/add-customers-address/${customerId}`)
              }
              className="w-full flex items-center justify-center gap-2 text-sm font-medium text-[#FF6943] border border-dashed rounded-xl py-3 hover:bg-orange-50"
            >
              <span className="text-lg">＋</span> Add New Address
            </button>
          ) : (
            <InputBase
              type="textarea"
              variant="location"
              value={customersAdd}
              disabled
              onChangeLocation={() =>
                navigate(`/address/${encryptId(customerId)}`)
              }
              rows={2}
              className="mt-6 text-xs text-orange-500 bg-gray-50 rounded-xl"
            />
          )}

          <div
            className={`mt-6 rounded-2xl p-6 text-white text-center shadow-md ${
              amountDu > 0
                ? "bg-gradient-to-br from-green-400 to-green-300"
                : amountDu < 0
                  ? "bg-gradient-to-br from-[#FF6943] to-[#ff8a6d]"
                  : "bg-white"
            }`}
          >
            <h1
              className={`text-3xl  font-bold tracking-tight ${amountDu > 0 ? "text-white" : amountDu < 0 ? "text-white" : "text-black"}`}
            >
              {Curr} {Number(Math.abs(amountDu)).toFixed(2)}
            </h1>
            <p className="mt-1 text-sm opacity-90">
              {amountDu > 0 ? (
                <span className="text-green-900 font-bold">Surplus Amount</span>
              ) : (
                <span className="text-red-900 font-bold">Amount Due</span>
              )}
            </p>
          </div>

          <div className="border-t border-gray-100 mt-4" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6">
            <div className="rounded-xl border bg-gray-50 p-4 text-center">
              <h3 className="text-lg font-semibold text-gray-900">
                {Curr}
                {totalAm}
              </h3>
              <p className="text-sm text-gray-500">Total Amount</p>
            </div>

            <div className="rounded-xl border bg-gray-50 p-4 text-center">
              <h3 className="text-lg font-semibold text-gray-900">
                {Curr}
                {paymentRc}
              </h3>
              <p className="text-sm text-gray-500">Payment Received</p>
            </div>

            <div className="rounded-xl border bg-gray-50 p-4 text-center">
              <h3 className="text-lg font-semibold text-gray-900">{totalTC}</h3>
              <p className="text-sm text-gray-500">Total Tiffins Consumed</p>
            </div>
          </div>

          <div className="border-t border-gray-100" />

          <div className="mt-6 flex flex-wrap gap-4 justify-between items-center rounded-xl border border-orange-200 bg-orange-50 p-4">
            <div className="flex items-center gap-3">
              <img src={subscriber} className="h-5 w-5" />
              <p className="text-base font-medium text-gray-900">
                {subscribeCount} Active Subscription
              </p>
            </div>

            <SecondaryBtn
              btnName="View"
              extraClass="px-6 h-10"
              clickEvent={handleSubscription}
            />
          </div>

          <div className="grid grid-cols-1 place-items-center px-0 md:px-4 pb-4 md:pb-2 sm:grid-cols-2 xl:grid-cols-4 gap-4 mt-6">
            <SecondaryBtn
              btnName="Collect Payment"
              clickEvent={() => setIsPayopen(true)}
            />
            <SecondaryBtn
              btnName="View Balance Sheet"
              clickEvent={handleBalanceView}
            />
            <SecondaryBtn
              btnName="Order History"
              clickEvent={handleOrderView}
            />
            <SecondaryBtn
              btnName="Payment History"
              clickEvent={handlePayView}
            />
          </div>
        </div>
      </div>
      <Collectpay
        open={isPayopen}
        onClose={() => setIsPayopen(false)}
        fromDetail={true}
        customerRawData={{
          customerId,
          customer_name: customerName,
          contact_no: customerNumber,
          country_code: customerCode,
          default_address: isAddress,
          total_amount: totalAm,
          payment_received: paymentRc,
          amount_due: amountDu,
          balance_type: BalanceType,
          currency_symbol: Curr,
        }}
      />
      <Editcustomer
        open={isEditCustomer}
        onClose={() => setIsEditCustomer(false)}
        onUpdated={fetchCustomerDetail}
        customerId={customerId}
      />
    </section>
  );
};

export default Detail;
